module.exports = __webpack_public_path__ + "media/images/delete-f819954d.svg";